import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 w-full h-full flex" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "block absolute top-0 left-0 w-full h-full bg-gradient-to-bl from-black/0 via-black/50 to-black"
}
const _hoisted_5 = { class: "relative container-default max-w-2xl space-y-8 text-center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCenteredSection',
  props: ["id", "src", "alt", "gradient"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _directive_parallax = _resolveDirective("parallax")!
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createElementBlock("section", {
    id: __props.id,
    class: "relative overflow-hidden"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("img", {
        src: __props.src,
        alt: __props.alt || __props.id,
        class: "w-full object-cover object-left-bottom"
      }, null, 8, _hoisted_3), [
        [_directive_parallax, {
                    from: { yPercent: 25, scale: 1.5 },
                    to: { yPercent: -25, scale: 1.5 },
                }]
      ])
    ]),
    (!!__props.gradient)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])), [
      [
        _directive_animate,
        void 0,
        void 0,
        { stagger: true }
      ]
    ])
  ], 8, _hoisted_1))
}
}

})